import { useContext } from 'react';
import { WorkspaceContext } from '@repo/utils/context';

export const useWorkspaceContext = () => useContext(WorkspaceContext);
